import { render, staticRenderFns } from "./companyverifycheck.vue?vue&type=template&id=bc1f58d4&scoped=true&"
import script from "./companyverifycheck.vue?vue&type=script&lang=js&"
export * from "./companyverifycheck.vue?vue&type=script&lang=js&"
import style0 from "./companyverifycheck.vue?vue&type=style&index=0&id=bc1f58d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1f58d4",
  null
  
)

export default component.exports